<template>
    <div class="qw-row flex-nowrap">
		<div :class="{disabled: disabled}">
			<img :src="iconSrc" style="width: 50px;" :class="{'img-grayscale': disabled}">

		</div>
		<div class="col" :class="{disabled: disabled}">
			<div><strong>{{title}}</strong></div>
			<div>{{description}}</div>
		</div>
		<div>
			<el-button v-if="isButtonVisible" @click="onButtonClickedHandler" size="small" plain type="primary" :loading="loading">{{buttonTitle}}</el-button>
			<div v-else>{{buttonTitle}}</div>
		</div>

	</div>
</template>

<script>
    export default {
        name: "PaymentMethodRow",
		props:{
			iconSrc: String,
        	title: String,
			description: String,
			buttonTitle:{type: String, default: "Connect"},
			isButtonVisible:{type: Boolean, default: true},
			loading:{type: Boolean, default: false},
			disabled: Boolean

		},
		methods:{
			onButtonClickedHandler(){
				this.$emit("onButtonClicked")
			}
		}
    }
</script>

<style>

</style>
